document.querySelectorAll('[data-open-modal]').forEach(btn => {
  btn.addEventListener('click', () => {
    const targetId = btn.dataset.openModal;
    const modal = document.querySelectorAll(`.modal[data-modal-id=${ targetId }]`)[0];
    document.body.classList.add('modal-' + targetId + '--open');
    modal.setAttribute('aria-hidden', 'false');
  });
});

document.querySelectorAll('[data-close-modal]').forEach(btn => {
  btn.addEventListener('click', () => {
    const modal = btn.closest('.modal');
    if (modal) {
      const targetId = modal.dataset.modalId;
      document.body.classList.remove('modal-' + targetId + '--open');
      modal.setAttribute('aria-hidden', 'true');
    }
  });
});